import React from 'react';
import {COLORS} from '../../../../../constants/colors';
import {Icon} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';
import {BasicControl} from './BasicControl';

export const UnmuteControl: React.FC<{
  unmuteFunction: () => void;
}> = ({unmuteFunction}) => {
  return (
    <BasicControl onClick={unmuteFunction}>
      <Icon
        asset={GenericIconName.Mute}
        width={20}
        height={20}
        fillOpacity={0.6}
        strokeWidth={2}
        fill={COLORS.White}
      />
    </BasicControl>
  );
};
